(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CurrencyPair', CurrencyPair);

    CurrencyPair.$inject = ['$resource'];

    function CurrencyPair ($resource) {
        var resourceUrl =  'api/currencyPair/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
